// src/lib/controles-suivi-api.js — LES CONTRÔLES DES RUNS AFFICHÉS AU SUIVI.
//
// Lecture DIRECTE supabase client de `menage_controles` — la RLS cloisonne
// (SELECT : admin = tout, orchestrateur = pool, contrôleur = ses contrôles ;
// le proprio n'a AUCUNE policy → 0 ligne par construction). UNE requête pour
// N runs (jamais une requête par bloc), déclenchée par la vue quand le
// RÉSULTAT des runs arrive (règle guichet : jamais au chargement).
//
// BEST-EFFORT : toute erreur rend {} — pas de pastilles, jamais un écran
// cassé. Le contrôle le plus récent de chaque run fait foi (tri desc → le
// premier vu est gardé), même règle que controle_a_controler côté serveur.

/**
 * runIds → { [run_id]: { id, run_id, statut, reprise_par, points, cree_le,
 * controleur_email } } (le contrôle LE PLUS RÉCENT de chaque run).
 *
 * `controleur_email` (panneau du ménage, recadrage Dimitri 2026-08-19) : servi
 * TOUJOURS — l'admin ET l'orchestrateur voient qui a contrôlé (« contrôlé par
 * [prénom] »). Le SEUL profil qui ne doit jamais le savoir est l'AGENT
 * CONTRÔLÉ — et il ne passe pas par ce batch (la RLS ligne cloisonne déjà :
 * admin tout, orchestrateur pool, proprio 0 ligne).
 */
export async function chargerControlesParRun(supabase, runIds) {
  const ids = [...new Set((runIds || []).filter(Boolean))]
  if (!ids.length) return {}
  try {
    const { data, error } = await supabase
      .from('menage_controles')
      .select('id, run_id, statut, reprise_par, points, cree_le, controleur_email, decide_le')
      .in('run_id', ids)
      .order('cree_le', { ascending: false })
    if (error) {
      console.error('[suivi] controles', error.message || error)
      return {}
    }
    const par = {}
    for (const c of data || []) {
      if (c?.run_id && !par[c.run_id]) par[c.run_id] = c
    }
    return par
  } catch (e) {
    console.error('[suivi] controles', e?.message || e)
    return {}
  }
}
